//
const wysiwygWidget = require('../utils/wysiwygWidget.js');

//
const wysiwygItemsSimple   = document.querySelectorAll('[data-wysiwyg="simple"]');
const wysiwygItemsAdvanced = document.querySelectorAll('[data-wysiwyg="full"]');
const wysiwygItemsCustom   = document.querySelectorAll('[data-wysiwyg="custom"]');

//
(async () => {

    //
    wysiwygItemsSimple.forEach((wysiwygItem) => {
        wysiwygWidget.createSimpleContentEditor(wysiwygItem);
    });

    //
    wysiwygItemsAdvanced.forEach((wysiwygItem) => {
        wysiwygWidget.createFullContentEditor(wysiwygItem);
    });

    //
    wysiwygItemsCustom.forEach((wysiwygItem) => {
        wysiwygWidget.createCustomContentEditor(wysiwygItem, JSON.parse(wysiwygItem.dataset?.wysiwygButtons ?? '{}'));
    });
    
})();